module.exports = __webpack_public_path__ + "img/slider.e36b9fde.png";